var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9823_16467)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.75V3.125C6 3.74632 6.50368 4.25 7.125 4.25H10.875C11.4963 4.25 12 3.74632 12 3.125V2.75H13.5C14.3284 2.75 15 3.42157 15 4.25V16.25C15 17.0784 14.3284 17.75 13.5 17.75H4.5C3.67157 17.75 3 17.0784 3 16.25V4.25C3 3.42157 3.67157 2.75 4.5 2.75H6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15625 12.3125C7.97656 12.3125 7.79687 12.2406 7.65312 12.0969L6.21562 10.6594C5.92813 10.3719 5.92813 9.94062 6.21562 9.65312C6.50313 9.36562 6.97031 9.36562 7.22187 9.65312L8.15625 10.5875L10.5281 8.21562C10.8156 7.92813 11.2469 7.92813 11.5344 8.21562C11.8219 8.50312 11.8219 8.93437 11.5344 9.22187L8.65937 12.0969C8.51562 12.2406 8.33594 12.3125 8.15625 12.3125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 2C8.25 1.58579 8.58579 1.25 9 1.25C9.41421 1.25 9.75 1.58579 9.75 2H10.875C11.0821 2 11.25 2.16789 11.25 2.375V3.125C11.25 3.33211 11.0821 3.5 10.875 3.5H7.125C6.91789 3.5 6.75 3.33211 6.75 3.125V2.375C6.75 2.16789 6.91789 2 7.125 2H8.25Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9823_16467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCert);
export default __webpack_public_path__ + "static/media/cert.c35606a9d5f8d89f5458b357f2f44575.svg";
export { ForwardRef as ReactComponent };